import * as cryptojs from 'crypto-js';

export class GdkCrypto {

  constructor() {
  }

  static getMd5(str: string): string {
    return cryptojs.MD5(str).toString();
  }

  static getRandomString(byteLenght: number): string {

    return cryptojs.lib.WordArray.random(byteLenght);
  }

  static generateKeyAES(p: string): string {
    const salt = cryptojs.lib.WordArray.random(128 / 8);
    return cryptojs.PBKDF2(p, salt, {keySize: 512 / 32, iterations: 1000}).toString();
  }

  static encryptAES(text: string): string {
    const password = this.generateKeyAES(cryptojs.lib.WordArray.random(16).toString());

    const iv = cryptojs.lib.WordArray.random(16);
    const salt = cryptojs.lib.WordArray.random(32);
    const cipher = cryptojs.AES.encrypt(text, password, {iv: iv, mode: cryptojs.mode.CBC, padding: cryptojs.pad.Pkcs7});

    return salt + password + iv + cipher.toString();

  }

  static decryptAES(text: string): string {

    const password = text.substr(96, 128);
    const iv = text.substr(64, 32);
    const salt = text.substr(0, 64);
    const encryptedText = text.substr(224);

    const decipher = cryptojs.AES.decrypt(encryptedText, password, {iv: iv, mode: cryptojs.mode.CBC, padding: cryptojs.pad.Pkcs7});

    return decipher.toString(cryptojs.enc.Utf8);
  }


}
